import { useEffect } from 'react';

import { startGlobalTelemetry } from '@/features/monitoring/lib/telemetry';

export function TelemetryBootstrap() {
  useEffect(() => startGlobalTelemetry(), []);
  return null;
}
